interface disableUfFieldsProps {
    [key: string]: boolean
}

const isDisableToEditContract = {
    'vehicles.chassi': true,
    'vehicles.renavam': true,
    'vehicles.ufGravame': true,
    'vehicles.uf': true,
    'vehicles.placa': true,
    'vehicles.anoFabricacao': true,
    'vehicles.anoModelo': true,
    'vehicles.identificacaoRemarcacao': true,
    'vehicles.cor': true,
    'vehicles.marca': true,
    'vehicles.especie': true,
    'vehicles.indicativoVeiculoNovo': true,
    'vehicles.numeroMotor': true,

    'complementary.identificadorTaxaMora': false,
    'complementary.valorTaxaMora': false,
    'complementary.identificadorTaxaMulta': false,
    'complementary.valorTaxaMulta': false,
    'complementary.valorIOF': false,
    'complementary.valorTaxaJurosMes': false,
    'complementary.valorTaxaJurosAno': false,
    'complementary.valorTaxaContrato': false,
    'complementary.indices': false,
    'complementary.identificadorComissao': false,
    'complementary.valorComissao': false,
    'complementary.indicacaoPenalidade': false,
    'complementary.penalidade': false,
    'complementary.principalRecebedorPagamento': true,
    'complementary.tipoDocumentoRecebedor': true,
    'complementary.documentoPrincipalRecebedorPagamento': true,
    'complementary.tipoDocumentoVendedor': true,
    'complementary.documentoVendedor': true,
    'complementary.comentarios': true,
    'complementary.numeroCertidaoNegativaDebitos': true,
    'complemantary.fundoReserva': true,

    'contract.dataContrato': true,
    'contract.numeroContrato': true,
    'contract.numeroGravame': true,
    'contract.tipoRestricao': true,
    'contract.quantidadeMeses': false,
    'contract.dataAditivo': true,
    'contract.numAditivoContrato': true,
    'contract.numAditivoContratoOrigem': true,
    'contract.numeroDudaPago': false,
    'contract.opcaoCompra': true,
    'contract.ufContrato': true,
    'contract.municipioContrato': true,

    'financing.valorTotalDivida': false,
    'financing.valorParcela': false,
    'financing.dataLiberacaoCredito': false,
    'financing.vencimentoPrimeiraParcela': false,
    'financing.vencimentoUltimaParcela': false,

    'consortium.numeroGrupo': false,
    'consortium.cotaConsorcio': false,

    'creditor.telefone': false,
    'creditor.cnpj': true,
    'creditor.razaoSocial': true,
    'creditor.endereco.cep': false,
    'creditor.endereco.logradouro': false,
    'creditor.endereco.complemento': false,
    'creditor.endereco.numero': false,
    'creditor.endereco.bairro': false,
    'creditor.endereco.municipio': true,
    'creditor.endereco.uf': true,

    'debtor.endereco.cep': false,
    'debtor.endereco.municipio': true,
    'debtor.endereco.uf': true,
    'debtor.endereco.bairro': false,
    'debtor.endereco.logradouro': false,
    'debtor.endereco.numero': false,
    'debtor.telefone': false,
    'debtor.endereco.complemento': false
} as disableUfFieldsProps

export default isDisableToEditContract
